import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/like', 
    //     name: 'like',
    //     component: () => import('@/components/Demo.vue'),
    //     props: {
    //         label: '收藏'
    //     }
    // },
    // {
    //     path: '/mine', 
    //     name: 'mine',
    //     component: () => import('@/components/Demo.vue'),
    //     props: {
    //         label: '我的'
    //     }
    // },
    // {
    //     path: '/privacyPolicy', 
    //     name: 'privacyPolicy',
    //     component: () => import('@/components/privacyPolicy/PrivacyPolicy.vue'),
    //     props: {
    //         label: '隐私协议'
    //     }
    // },
    {
        path: '/', 
        name: 'home',
        component: () => import('@/components/home/home.vue'),
        redirect: '/home',
        children: [
            {
                path: '/home',
                conponent: () => import('@/components/home/home.vue'),
            }
        ],
        props: {
            label: '首页'
        }
    },
    {
        path: '/wechatUserInfo', 
        name: 'wechatUserInfo',
        component: () => import('@/components/disparkModule/wechatUserInfo.vue'),
        props: {
            label: '微信信息'
        }
    },
    {
        path: '/wechatAuth', 
        name: 'wechatAuth',
        component: () => import('@/components/disparkModule/wechatAuth.vue'),
        props: {
            label: '微信授权'
        }
    },
    {
        path: '/mainProcess', 
        name: 'mainProcess',
        component: () => import('@/components/mainProcess/mainProcess.vue'),
        props: {
            label: '主流程'
        }
    },
    {
        path: '/vehicleDetection', 
        name: 'vehicleDetection',
        component: () => import('@/components/vehicleLicense/vehicleDetection.vue'),
        props: {
            label: '检测车辆办理'
        }
    },
    {
        path: '/authentication', 
        name: 'authentication',
        component: () => import('@/components/householder/authentication.vue'),
        props: {
            label: '户主身份证上传-认证'
        }
    },
    {
        path: '/vehicleCertify', 
        name: 'vehicleCertify',
        component: () => import('@/components/vehicleLicense/vehicleCertify.vue'),
        props: {
            label: '车辆发行验证'
        }
    },
    {
        path: '/vehicleLicense', 
        name: 'vehicleLicense',
        component: () => import('@/components/vehicleLicense/vehicleLicense.vue'),
        props: {
            label: '行驶证上传识别-认证'
        }
    },
    {
        path: '/signing', 
        name: 'signing',
        component: () => import('@/components/signing/signing.vue'),
        props: {
            label: '通行费代扣协议签约'
        }
    },
    {
        path: '/obu', 
        name: 'obu',
        component: () => import('@/components/order/obu.vue'),
        props: {
            label: 'obu下单确认页面'
        }
    },
    {
        path: '/issue', 
        name: 'issue',
        component: () => import('@/components/issue/issue.vue'),
        props: {
            label: '选择发行方'
        }
    },
    {
        path: '/issueList', 
        name: 'issueList',
        component: () => import('@/components/issue/issueList.vue'),
        props: {
            label: '发行方列表'
        }
    },
    {
        path: '/creditBank', 
        name: 'creditBank',
        component: () => import('@/components/creditBank/creditBank.vue'),
        props: {
            label: '选择授信银行'
        }
    },
    {
        path: '/vehicleInfo', 
        name: 'vehicleInfo',
        component: () => import('@/components/myETC/vehicleInfo.vue'),
        props: {
            label: '车辆信息'
        }
    },
    {
        path: '/vehicleInfoInquire', 
        name: 'vehicleInfoInquire',
        component: () => import('@/components/disparkModule/vehicleInfoInquire.vue'),
        props: {
            label: '车辆信息查询'
        }
    },
    {
        path: '/inquireVehicleInfo', 
        name: 'inquireVehicleInfo',
        component: () => import('@/components/disparkModule/inquireVehicleInfo.vue'),
        props: {
            label: '查询车辆信息'
        }
    },
    {
        path: '/signInfo', 
        name: 'signInfo',
        component: () => import('@/components/myETC/signInfo.vue'),
        props: {
            label: '签约信息'
        }
    },
    {
        path: '/creditInfo', 
        name: 'creditInfo',
        component: () => import('@/components/myETC/creditInfo.vue'),
        props: {
            label: '授信信息'
        }
    },
    {
        path: '/installActivate', 
        name: 'installActivate',
        component: () => import('@/components/myETC/installActivate.vue'),
        props: {
            label: '安装激活'
        }
    },
    // {
    //     path: '/creditGranting', 
    //     name: 'creditGranting',
    //     component: () => import('@/components/myETC/creditGranting.vue'),
    //     props: {
    //         label: '授信'
    //     }
    // },
    {
        path: '/limitInquire', 
        name: 'limitInquire',
        component: () => import('@/components/myETC/limitInquire.vue'),
        props: {
            label: '额度查询'
        }
    },
    {
        path: '/myOrder', 
        name: 'myOrder',
        component: () => import('@/components/myETC/myOrder.vue'),
        props: {
            label: '账单查询'
        }
    },
    // {
    //     path: '/personalData', 
    //     name: 'personalData',
    //     component: () => import('@/components/myETC/personalData.vue'),
    //     props: {
    //         label: '个人资料'
    //     }
    // },
    {
        path: '/followUp', 
        name: 'followUp',
        component: () => import('@/components/progressQuery/followUp.vue'),
        props: {
            label: '订单查询'
        }
    },
    {
        path: '/orderInfo', 
        name: 'orderInfo',
        component: () => import('@/components/disparkModule/orderInfo.vue'),
        props: {
            label: '订单信息'
        }
    },
    // {
    //     path: '/agrPlyNoInfo', 
    //     name: 'agrPlyNoInfo',
    //     component: () => import('@/components/progressQuery/agrPlyNoInfo.vue'),
    //     props: {
    //         label: '进度查询'
    //     }
    // },
    // {
    //     path: '/plyNoInfo', 
    //     name: 'plyNoInfo',
    //     component: () => import('@/components/progressQuery/plyNoInfo.vue'),
    //     props: {
    //         label: '进度查询'
    //     }
    // },
    {
        path: '/lineServe', 
        name: 'lineServe',
        component: () => import('@/components/progressQuery/lineServe.vue'),
        props: {
            label: '在线客服'
        }
    },
    {
        path: '/issueDetails', 
        name: 'issueDetails',
        component: () => import('@/components/progressQuery/issueDetails.vue'),
        props: {
            label: '问题详情'
        }
    },
    // {
    //     path: '/bankCreditHang', 
    //     name: 'bankCreditHang',
    //     component: () => import('@/components/ETCwithholding/bankCreditHang.vue'),
    //     props: {
    //         label: '银行授信挂起'
    //     }
    // },
    // {
    //     path: '/creditWithholding', 
    //     name: 'creditWithholding',
    //     component: () => import('@/components/ETCwithholding/creditWithholding.vue'),
    //     props: {
    //         label: '授信代扣'
    //     }
    // },
    // {
    //     path: '/noBankCredit', 
    //     name: 'noBankCredit',
    //     component: () => import('@/components/ETCwithholding/noBankCredit.vue'),
    //     props: {
    //         label: '未进行银行授信'
    //     }
    // },
    {
        path: '/Finish', 
        name: 'finish',
        component: () => import('@/components/order/orderFinish.vue'),
        props: {
            label: '订单完成'
        }
    },
    // {
    //     path: '/insuranceCredit', 
    //     name: 'insuranceCredit',
    //     component: () => import('@/components/myETC/insuranceCredit.vue'),
    //     props: {
    //         label: '保险增信'
    //     }
    // },
    {
        path: '/notice', 
        name: 'notice',
        component: () => import('@/components/notice/notice.vue'),
        props: {
            label: '发行说明'
        }
    },
    {
        path: '/newNotice', 
        name: 'newNotice',
        component: () => import('@/components/notice/newNotice.vue'),
        props: {
            label: '新办须知'
        }
    },
    {
        path: '/userServiceAgreement', 
        name: 'userServiceAgreement',
        component: () => import('@/components/notice/userServiceAgreement.vue'),
        props: {
            label: '用户服务协议'
        }
    },
    {
        path: '/noMessage', 
        name: 'noMessage',
        component: () => import('@/components/messageHint/noMessage.vue'),
        props: {
            label: '没有查到信息'
        }
    },
]

const router = new VueRouter({
    routes
  })

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});

export default router